import {Component, OnInit} from '@angular/core';
import {Licitacao} from '../../_classes/licitacao';
import {Arquivo} from '../../_classes/arquivo';
import {ActivatedRoute, Router} from '@angular/router';
import {Base64Service} from '../../services/base64.service';
import {LoadingService} from '../../services/loading.service';
import {LicitacaoService} from '../../services/licitacao.service';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {LicitacaoFilter} from '../../_classes/licitacaoFilter';

@Component({
  selector: 'app-licitacao-get-one',
  templateUrl: './licitacao-get-onecomponent.html',
  styleUrls: ['./licitacao-get-one.component.scss'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS}
  ]
})
export class LicitacaoGetOneComponent implements OnInit {

  load = false;
  licitacoes: Licitacao[];
  arquivos: Arquivo[];
  licitacaoFilter = new LicitacaoFilter();

  constructor(
    private adapter: DateAdapter<any>,
    private licitacaoService: LicitacaoService,
    private base64Service: Base64Service,
    private loadingService: LoadingService,
    private router: Router,
    private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.loadingService.currentLoading.subscribe(load => {
      this.load = load;
    });
    this.initLicitacao();
  }

  initLicitacao() {
    this.loadingService.changeLoading(true);

    this.licitacaoFilter.modalidade = this.getModalidadeLicitacao();
    this.licitacaoFilter.numeroDaLicitacao = this.getNumeroLicitacao();
    this.licitacaoFilter.orgao = this.getOrgaoLicitacao();

    this.licitacaoService.getLicitacoesByFilter(this.licitacaoFilter, null)
      .subscribe(result => {
        this.licitacoes = result;
        this.loadFiles(this.licitacoes[0].id);
        this.loadingService.changeLoading(false);
      }, error => {
        this.loadingService.changeLoading(false);
      });
  }

  private getModalidadeLicitacao() {
    const modalidadeOriginal = this.route.snapshot.paramMap.get('modalidade');

    // return modalidadeOriginal with all _ replaced by a space
    return modalidadeOriginal.replace(/_/g, ' ');
  }

  private getNumeroLicitacao() {
    return this.route.snapshot.paramMap.get('numero');
  }

  private getOrgaoLicitacao() {
    const orgaoOriginal = this.route.snapshot.paramMap.get('orgao');

    // return orgaoOriginal with all _ replaced by a space
    return orgaoOriginal.replace(/_/g, ' ');
  }

  private loadFiles(id: number) {
    this.arquivos = [];
    this.loadingService.changeLoading(true);
    this.licitacaoService.getArquivosDaLicitacao(id).subscribe(arquivos => {
      this.loadingService.changeLoading(false);
      this.arquivos = arquivos;
    });
  }

  download(arquivo: Arquivo) {
    this.loadingService.changeLoading(true);
    window.open(arquivo.valor);
    this.loadingService.changeLoading(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/licitacao-get-one/licitacao-get-one.component.ts